/* eslint-disable react/jsx-sort-props */
import * as React from 'react';
import * as vars from '../../styles/variables';
import AccessibleSVG, { SVGProps } from '../../components/accessible-svg/AccessibleSVG';

/**
 * This is an auto-generated component and should not be edited
 * manually in contributor pull requests.
 *
 * If you have problems with this component:
 * - https://github.com/box/box-ui-elements/issues/new?template=Bug_report.md
 *
 * If there are missing features in this component:
 * - https://github.com/box/box-ui-elements/issues/new?template=Feature_request.md
 */

const Relay16 = (props: SVGProps) => (
    <AccessibleSVG width={16} height={16} viewBox="0 0 16 16" {...props}>
        <path
            fill={vars.bdlGray50}
            fillRule="evenodd"
            d="M7.003 2l-1.94 3.668a.5.5 0 00.094.591L9.004 10l-4.056-.001 1.023 3.743a1 1 0 11-1.933.518l-3.004-11A1 1 0 012.001 2h5.002zM12.5 2a.5.5 0 01.458.7l-1.874 2.923a.5.5 0 00.112.663l3.679 2.882a.5.5 0 01-.375.83h-3.495L7.157 6.33a.5.5 0 01-.098-.592L9.004 2H12.5z"
        />
    </AccessibleSVG>
);

export default Relay16;
